import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedService } from './sharedService';

@Injectable({
  providedIn: 'root'
})
export class IssueTrackerService {
  constructor(
    private http: HttpClient,
    private sharedService: SharedService
  ) {}

  getIssues() {
    return this.http.get<any>(
      this.sharedService.apiUrl('issue-tracker/issues')
    );
  }

  submitIssue(data) {
    return this.http.post<any>(
      this.sharedService.apiUrl('issue-tracker/issues'),
      data
    );
  }
}
